/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75558Req {
  
  /** (String) */
  fileUrl?: string;
    
};



export interface API75558Res {
  /** 表头 ,String  */
  heads?: string[];
  /** 表数据 ,Map  */
  values?: any[];
  
};


// 接口函数 75558 文件上传

export interface IUseGetAPI75558Return {
  /** 文件上传: 接口请求状态 */
  isAPI75558Loading: boolean;
  /** 文件上传: 接口请求返回数据 */
  dataAPI75558: API75558Res;
  /**  文件上传: 接口数据请求方法 */
  fetchAPI75558Data: (inputs: API75558Req, config?: YWRequestConfig) => Promise<API75558Res>;
  /** 文件上传: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI75558 = ():IUseGetAPI75558Return => {
  let isMount = true;
  const [isAPI75558Loading, setIsAPI75558Loading] = useState(false);
  const [dataAPI75558, setDataAPI75558] = useState<API75558Res>({} as API75558Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/importV2`;

  const fetchAPI75558Data = async (inputs: API75558Req, config?: YWRequestConfig): Promise<API75558Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75558Req>) || {}) as API75558Req;
    
  
    if ( isMount ) {
      setIsAPI75558Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API75558Res>(`${basePath}/yoaichat-web/chat/task/model/importV2?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI75558(res || {} as API75558Res);
        setIsAPI75558Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75558Loading(false);
      }
      return false as unknown as API75558Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75558Loading,
    dataAPI75558,
    fetchAPI75558Data,
    requestUrl,
  }
}

